

//http://thelottofactoryapi.azurewebsites.net/v1/admin/draw/drawn?ApiKey=e0a13903-3158-4bc2-bbaf-aa07073d0bff
//DrawId: "EB270B34-FB78-4E9A-9800-F63541A6783F",
//TicketNumber: "0984460"
function AdminDrawTicketNumberSvc($resource) {
  'ngInject';
  var odataUrl = TFL_Base_Url + 'admin/draw/drawn'
  return $resource(odataUrl, {}, {
      post: { method: 'POST', params: { APIKey: '@APIKey', DrawId: '@DrawId', TicketNumber: '@TicketNumber'}, isArray: false }
  });
};

export default {
  name: "AdminDrawTicketNumberSvc",
  fn: AdminDrawTicketNumberSvc
}